module.exports = __webpack_public_path__ + "static/blog-post-3-e3f29c8862cc5cc5ac18609448c01e3d.png";